import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      margin: '23px -25px 15px',
    },
    box: {
      borderWidth: '1px 0 0 0',
      borderRadius: '0 0 4px 4px',
      marginTop: 0,
      padding: 0,
    },
    label: {
      '& svg': {
        fontSize: 14,
        fill: '#777777',
      },
    },
    listItem: {
      paddingLeft: 24,
      paddingRight: 24,
    },
    iconRoot: {
      marginRight: -5,
    },
    buttonClass: {
      backgroundColor: '#fff',
      boxShadow: 'none',
      padding: '14px 24px',
      color: theme.palette.primary.main,
      textTransform: 'capitalize',
      fontSize: '13px',
      borderTop: '1px solid #EEE',
      borderBottom: '1px solid #EEE',
      '&:hover': {
        backgroundColor: '#fff',
        boxShadow: 'none',
      },
    },
    buttonClassExtended: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      border: 0,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        border: 0,
      },
    },
  };
});

export { useStyles };
